import {
  AuthenticationResult,
  Configuration,
  EventMessage,
  EventType,
  IPublicClientApplication,
  PublicClientApplication,
} from "@azure/msal-browser";

export async function initialize(authConfig: {
  clientId: string;
  authority: string;
}): Promise<IPublicClientApplication> {
  const msalConfig: Configuration = {
    auth: {
      clientId: authConfig.clientId,
      authority: authConfig.authority,
      redirectUri: "/",
      postLogoutRedirectUri: "/",
    },
  };

  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance!.setActiveAccount(account);
    }
  });

  msalInstance.handleRedirectPromise().then((res) => {
    if (res !== null) {
      msalInstance!.setActiveAccount(res.account);
    }
  });

  return msalInstance;
}

export async function acquireToken(
  msalInstance: IPublicClientApplication,
  tokenConfig: { scopes: string[] }
): Promise<string> {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw Error("No active account.");
  }

  const response = await msalInstance.acquireTokenSilent({
    scopes: tokenConfig.scopes,
    account: account,
  });

  return response.accessToken;
}

export async function login(
  msalInstance: IPublicClientApplication,
  tokenConfig: { scopes: string[] }
): Promise<void> {
  try {
    await msalInstance.loginPopup({ scopes: tokenConfig.scopes });
  } catch (err) {
    await msalInstance.loginRedirect({ scopes: tokenConfig.scopes });
  }
}

export async function logout(
  msalInstance: IPublicClientApplication
): Promise<void> {
  try {
    await msalInstance.logoutPopup();
  } catch (err) {
    await msalInstance.logoutRedirect();
  }
}
